global css html ff:'Poppins',sans bgc:#151515 c:#fff
global css body m:0
global css .header pos:fixed t:1.4rem r:1.4rem zi:5
global css .logo img w:60px


import { Data } from './data/projects.imba'

import { Home } from './pages/home'
import { Project } from './pages/projects/project'
import { TopMenu } from './components/global/topmenu'

tag App
	def build
		db = new Data
		await db.init()

	def render
		<self>
			<header.header>
				<div.logo>
					<a route-to="/">
						<img src="./images/logo.png">
				# <TopMenu>
			<main>
				<Home.page route="$" db=db>
				<Project.page route="/projects/:title" db=db>

imba.mount <App>
